import i18n, { FallbackLng } from "i18next";
import { initReactI18next } from "react-i18next";
import { Mutex } from "async-mutex";
import Backend, { HttpBackendOptions } from "i18next-http-backend";
import type { InitOptions } from "i18next";

const mutex = new Mutex();
let initialized = false;

export class I18NextInitializer {
  lng?: string;
  fallbackLng?: false | FallbackLng;
  debug?: boolean;
  useHttpBackend: boolean;

  constructor(args?: {
    lng?: string;
    fallbackLng?: false | FallbackLng;
    debug?: boolean;
    useHttpBackend?: boolean;
  }) {
    this.lng = args?.lng;
    this.fallbackLng = args?.fallbackLng;
    this.debug = args?.debug;
    this.useHttpBackend = args?.useHttpBackend ?? false;
  }

  async init() {
    return mutex.runExclusive(async () => {
      if (!initialized) {
        console.log("i18n init...");
        let i18nInstance = i18n;
        if (this.useHttpBackend) {
          i18nInstance = i18nInstance.use(Backend);
        }
        const optionsWithBackend: InitOptions<HttpBackendOptions> = {
          lng: this.lng,
          fallbackLng: this.fallbackLng,
          debug: this.debug,
          react: {
            useSuspense: true,
          },
          interpolation: {
            escapeValue: false,
          },
          backend: {
            loadPath: "assets/i18n/{{ns}}/{{lng}}.json",
          },
        };
        const optionsWithoutBackend: InitOptions = {
          lng: this.lng,
          fallbackLng: this.fallbackLng,
          debug: this.debug,
          interpolation: {
            escapeValue: false,
          },
          resources: {},
        };
        return await i18nInstance
          .use(initReactI18next)
          .init(
            this.useHttpBackend ? optionsWithBackend : optionsWithoutBackend,
            () => {
              initialized = true;
            }
          );
      } else {
        console.log("i18n already initialized");
      }
    });
  }
}
